export const thingsAboutMe = [
  {
    title: "En principio...",
    text: "Mi nombre es Karen Rodriguez, soy de Bolivia.",
  },
  {
    title: "Estudios...",
    text: "Estudio Ingeniera en Sistemas en la Universidad Autónoma Gabriel René Moreno. Me gusta estar en constante aprendizaje, por ello he aprendido varios idiomas como ingles, frances y portugues, tengo planeado seguir con aleman.",
  },
  {
    title: "Hobbies",
    text: "Me encanta pintar con acuarelas y hacer lettering. En deportes solo me gusta trotar y nadar.",
  },
  {
    title: "Comunidades",
    text: "Soy fanatica de apoyar a comunidades de programacion y Software Libre como la GDG, y Nucleo Linux.",
  },
];
